var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSection',{attrs:{"title":_vm.title,"padding":"0"}},[(_vm.extras && _vm.selected)?_c('div',_vm._l((_vm.extras),function(extra){return _c('ProductExtras',{key:extra.CODMODIFICADOR,attrs:{"extras":{extra: extra}},on:{"optionSelected":_vm.onOptionSelected}})})):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002078fb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/ProductExtrasSelector.vue
// module id = null
// module chunks = 